module.exports = __webpack_public_path__ + "static/media/muir_lounge.e7362831.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/video/muir_lounge.mov
// module id = 987
// module chunks = 0